import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import SFTypography from "../typography";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    ...theme.typography.tableHeader,
    paddingTop: 10,
    paddingBottom: 10,
  },
  [`&.${tableCellClasses.body}`]: {
    paddingTop: 8,
    paddingBottom: 8,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const SFTypographyStyledBodyRow = styled(SFTypography)(({ theme }) => ({
  overflow: "hidden",
  whiteSpace: "normal",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical"
}));

const SFTable = (props) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: props.minWidth }}>
        <TableHead>
          <TableRow>
            {props.headers.map((key) => {
              return <StyledTableCell key={key}>{key}</StyledTableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.map((row, index) => {
            let rowKeys = Object.keys(row);
            if (props.columns) {
              rowKeys = rowKeys.filter((a) => props.columns.indexOf(a) >= 0);
            }
            return (
              <StyledTableRow
                key={`row-${index}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {rowKeys.map((key, i) => (
                  <StyledTableCell key={`cell-${index}-${i}`} component="th">
                    <SFTypographyStyledBodyRow variant="tableList">
                      {row[key]}
                    </SFTypographyStyledBodyRow>
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

SFTable.defaultProps = {
  minWidth: 650,
};
SFTable.propTypes = {
  minWidth: PropTypes.number,
  headers: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.object),
};

export default SFTable;
